// The generated OpenAPI types collapse x-extensible-enum fields to plain `string`, so the actual
// enum values are declared locally here, mirroring `WorkshopFeedback` / `CustomerFeedback` in
// `vehicle-warnings-api.yml`.

export const WORKSHOP_FEEDBACK_OPTIONS = [
    'WORKSHOP_VISIT_PLANNED',
    'CUSTOMER_CONTACTED',
    'COMPONENT_CHECKED',
    'DECIDED_NO_ACTION',
    'SOLVED',
    'NO_RESPONSE',
    'OTHERS',
] as const;

export const CUSTOMER_FEEDBACK_OPTIONS = [
    'WORKSHOP_VISIT_PLANNED',
    'WORKSHOP_CONTACTED',
    'COMPONENT_CHECKED',
    'DECIDED_NO_ACTION',
    'SOLVED',
    'NO_RESPONSE',
    'OTHERS',
] as const;

export type WorkshopFeedbackClassification = (typeof WORKSHOP_FEEDBACK_OPTIONS)[number];
export type CustomerFeedbackClassification = (typeof CUSTOMER_FEEDBACK_OPTIONS)[number];

export const OTHERS_CLASSIFICATION = 'OTHERS';

export interface FeedbackFormValues {
    serviceActionRequired: boolean | undefined;
    workshopFeedback: WorkshopFeedbackClassification | undefined;
    workshopFeedbackOthers: string;
    customerFeedback: CustomerFeedbackClassification | undefined;
    customerFeedbackOthers: string;
    comments: string;
}

export const EMPTY_FEEDBACK_FORM_VALUES: FeedbackFormValues = {
    serviceActionRequired: undefined,
    workshopFeedback: undefined,
    workshopFeedbackOthers: '',
    customerFeedback: undefined,
    customerFeedbackOthers: '',
    comments: '',
};
